/*global jQuery:readonly */
import * as React from "react";
import { NotificationManager } from "react-notifications";

import { AchievementValidation } from "../data";
import { notifyServerErrorOrDefault } from "../helpers";

interface ValidateState {
    achievements: AchievementValidation[];
}

class Validate extends React.Component<{}, ValidateState> {

    state: ValidateState = {
        achievements: []
    };

    private achievementsLoaded: boolean = false;

    constructor(props: {}) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    get achievements(): JSX.Element | JSX.Element[] {
        if (!this.achievementsLoaded) {
            return (
                <div className="row">
                    <div className="col-xs-12">Loading...</div>
                </div>
            );
        }

        if (!this.state.achievements.length) {
            return (
                <div className="row">
                    <div className="col-xs-12">There are no items to validate</div>
                </div>
            );
        }

        return this.state.achievements.map((achievement, idx: number): JSX.Element => {
            return (
                <div key={ idx }>
                    <div className="row">
                        <div className="col-xs-12">
                            <h3>{ achievement.codename }</h3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <p>
                                Wants a medal for
                                &nbsp;
                                <span style={ { color: "#00bab5" } }>{ achievement.achievementName }</span>
                                &nbsp;
                                (currently level { achievement.currentLevel })
                                &nbsp;
                                {/* TODO(honles): this is bad :( */ }
                                <span dangerouslySetInnerHTML={ { __html: achievement.text } }/>
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12"><p>{ achievement.status }</p></div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="btn-group" role="group" aria-label="Achievement validations actions">
                                <button
                                    onClick={ (e): void => this.handleClick(e, "approve", achievement) }
                                    type="button"
                                    className="btn btn-primary"
                                >
                                    Approve
                                </button>
                                <button
                                    onClick={ (e): void => this.handleClick(e, "reject", achievement) }
                                    type="button"
                                    className="btn btn-default"
                                >
                                    Reject
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <hr/>
                        </div>
                    </div>
                </div>
            );
        });
    }

    UNSAFE_componentWillMount(): void {
        jQuery.getJSON("/backend/toolbox/validate").then(
            (data): void => {
                this.achievementsLoaded = true;
                this.setState({
                    achievements: data.achievements.map((achievement): any => {
                        return {
                            achievementName: achievement.achievement_name,
                            codename: achievement.codename,
                            currentLevel: +(achievement.current_level || 0),
                            logId: +achievement.log_id,
                            status: achievement.status,
                            text: achievement.text,
                            userId: +achievement.user_id
                        };
                    })
                });
            },
            (ajax): void => {
                notifyServerErrorOrDefault(ajax, "Could not load achievements");
            });
    }

    handleClick(
        e: React.MouseEvent<HTMLButtonElement>,
        action: string,
        achievement: AchievementValidation): void {
        e.preventDefault();
        const pastAction = action === "approve" ? "approved" : "rejected";

        jQuery.post("/backend/toolbox/validate", { action: action, id: achievement.logId }).then(
            (): void => {
                NotificationManager.success(`Achievement ${ pastAction }`);
                this.setState((state: ValidateState): ValidateState => {
                    return { ...state, achievements: state.achievements.filter((a): boolean => a !== achievement) };
                });
            },
            (ajax): void => {
                notifyServerErrorOrDefault(ajax, `Could not ${ pastAction } achievement`);
            });
    }

    render(): JSX.Element {
        return (
            <div>
                <div className="row" id="header">
                    <div className="col-xs-12">
                        <h2>Validate Achievements</h2>
                    </div>
                </div>

                { this.achievements }
            </div>
        );
    }
}

export default Validate;
